import { render } from "./PendingDispatch.vue?vue&type=template&id=44469664&scoped=true"
import script from "./PendingDispatch.vue?vue&type=script&lang=js"
export * from "./PendingDispatch.vue?vue&type=script&lang=js"

import "./PendingDispatch.vue?vue&type=style&index=0&id=44469664&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44469664"]])

export default __exports__